import styled from "styled-components";
import { Modal } from "antd";

const StyledModal = styled(Modal)`
  &.ant-modal {
    .ant-modal-content {
      padding: 32px;
    }

    h3 {
      color: #1e1919;
      font-size: 18px;
      line-height: 19px;
      margin: 0 0 24px;
    }

    p {
      margin: unset;
    }

    img {
      height: fit-content;
      width: 160px;
    }
  }
`;

export default StyledModal;
